import {
	IMessageBoxResolvePayload,
	MessageBox,
	MessageBoxButton,
	MessageBoxButtons
} from '@bimser/common';
import { RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import { MLHelper } from '@bimser/core';
import { call } from 'redux-saga/effects';
import { runAction } from './runAction';
import { findMessage } from '@bimser/components';

export interface IRunConfirmationAction {
	rule: RuleEngineEntities.IRule;
	checkType: 'preview' | 'execution';
	windowId: string;
}

export function* runShowConfirmationAction(
	condition: RuleEngineEntities.IConfirmationCondition,
	args: IRunConfirmationAction
) {
	const { rule, checkType, windowId } = args;
	let result = false;

	const boxResponse: IMessageBoxResolvePayload = yield MessageBox.confirm({
		title: findMessage.get('101878'),
		content: MLHelper.getMLText(condition.messages),
		buttons: MessageBoxButtons.OKCancel
	});

	if (boxResponse) {
		switch (boxResponse.button.id) {
			case MessageBoxButton.OK: {
				if (condition.onSuccess?.referenceId) {
					const actionGroup = args.rule.actionGroups[condition.onSuccess.referenceId];
					const actions = Object.values(args.rule.actions).filter(action =>
						actionGroup.includes(action.id)
					);
					const actionPromiseResults = yield call(runAction, {
						actions,
						rule,
						checkType,
						windowId
					});
					result = !!actionPromiseResults.filter(Boolean).length;
				}

				break;
			}
			case MessageBoxButton.Cancel: {
				if (condition.onFailure?.referenceId) {
					const actionGroup = rule.actionGroups[condition.onFailure.referenceId];
					const actions = Object.values(rule.actions).filter(action =>
						actionGroup.includes(action.id)
					);
					const actionPromiseResults = yield call(runAction, {
						actions,
						rule,
						checkType,
						windowId
					});
					result = !!actionPromiseResults.filter(Boolean).length;
				}

				break;
			}
		}
	}

	return result;
}
